import React from 'react';
import {
  Timer as TimerIcon,
} from '@material-ui/icons';
import IdleStatusBadge from '../IdleStatusBadge';

// Função para calcular tempo total na pipeline
const calculateTotalTimeInPipeline = entryDate => {
  if (!entryDate) return 0;

  const entryDateObj = new Date(entryDate);
  const now = new Date();
  const diffInMs = now - entryDateObj;
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

  return diffInHours;
};

const formatTotalTimeDisplay = hours => {
  if (hours < 24) {
    return `${hours}h`;
  } else {
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    return `${days}d ${remainingHours}h`;
  }
};

const IdleIndicator = ({
  ticket,
  showTotalTime = true,
  showIdleTime = false,
  totalTimeLabel = 'Total na pipeline',
  idleTimeLabel = 'Tempo de ociosidade',
  textFontSize = 9,
  iconFontSize = 10,
  idleBadgeSize = 'small',
}) => {
  // Usar o campo idleStatus do backend (nova estrutura)
  const idleStatusData = ticket?.idleStatus;
  const totalHours = calculateTotalTimeInPipeline(ticket?.createdAt);
  // Só mostrar ociosidade se a última mensagem não for minha
  const shouldShowIdleStatus = idleStatusData && !ticket?.fromMe;
  const idleMinutes =
    typeof idleStatusData?.minutesIdle === 'number' ? idleStatusData.minutesIdle : null;

  return (
    <div>
      {showTotalTime && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            fontSize: `${textFontSize}px`,
            color: 'inherit',
            marginTop: '2px',
            fontWeight: 'normal',
          }}
        >
          <TimerIcon style={{ fontSize: `${iconFontSize}px` }} />
          <div
            style={{ display: 'grid' }}>
            <span
              style={{
                fontSize: `11px`,
                opacity: 0.75,
                color: 'inherit',
              }}>
              {totalTimeLabel}:
            </span>
            <span
              style={{
                fontSize: `12px`,
                fontWeight: 'bold',
              }}>
              {formatTotalTimeDisplay(totalHours)}
            </span>
          </div>
        </div>
      )}

      {showIdleTime && shouldShowIdleStatus && idleMinutes != null && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            fontSize: `${textFontSize}px`,
            color: 'inherit',
            marginTop: '2px',
            fontWeight: 'normal',
          }}
        >
          <IdleStatusBadge
            idleStatus={idleStatusData}
            variant='circle'
            size={idleBadgeSize}
            showTooltip={true}
          />
          {idleTimeLabel}: {idleMinutes}min
        </div>
      )}
    </div>
  );
};

export default IdleIndicator;
